import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../../lib/api";

export default function ForgotPassword() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await api.post("/admin/forgot-password", { email });
      // Pass email to next page via router state
      nav("/reset-password", { state: { email } });
    } catch (e) {
      setErr(e?.response?.data?.message || e.message || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white grid place-items-center p-4">
      <div className="w-full max-w-md border rounded-2xl p-6">
        <Link
          to="/login"
          className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-black mb-6 transition-colors"
        >
          ← Back to login
        </Link>

        <h1 className="text-2xl font-bold">Forgot Password</h1>
        <p className="text-sm text-gray-600 mt-1">
          Enter your admin email and we'll send a 6-digit OTP.
        </p>

        <form onSubmit={onSubmit} className="space-y-4 mt-6">
          <div>
            <label className="text-sm font-semibold">Email</label>
            <input
              type="email"
              required
              placeholder="admin@example.com"
              className="mt-2 w-full border rounded-xl px-3 py-2 outline-none focus:ring-2 focus:ring-black"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          {err && <div className="text-sm text-red-600">{err}</div>}

          <button
            disabled={loading}
            className="w-full bg-black text-white rounded-xl py-2 font-semibold hover:opacity-90 disabled:opacity-60"
          >
            {loading ? "Sending OTP..." : "Send OTP"}
          </button>
        </form>
      </div>
    </div>
  );
}